/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface GenerateFileResponse { 
    /**
     * Unique identifier of the file being uploaded.
     */
    file_descriptor_id: string;
    url: string;
    fields: any;
    /**
     * It is optional. Present only for files with public=true attribute
     */
    public_url?: string;
}